import { motion } from "framer-motion";
import AchievementBadge from "./AchievementBadge";

/** Celebration shown on a results screen for badges earned by that session. */
const AchievementUnlocked = ({ results }) => {
  const earned = results?.new_achievements || [];
  if (earned.length === 0) return null;

  return (
    <motion.div
      className="mb-6 space-y-3"
      initial={{ opacity: 0, scale: 0.94 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: "spring", stiffness: 260, damping: 20 }}
      data-testid="achievement-unlocked"
    >
      {earned.map((b) => (
        <div
          key={b.badge_id}
          className="flex items-center gap-4 border border-primary/40 bg-primary/5 p-4"
          data-testid={`achievement-unlocked-${b.badge_id}`}
        >
          <AchievementBadge badge={b} />
          <div className="text-left">
            <p className="text-xs uppercase tracking-widest text-primary">Badge unlocked</p>
            <p className="font-heading text-lg font-semibold">{b.title}</p>
            <p className="text-sm text-muted-foreground">{b.description}</p>
          </div>
        </div>
      ))}
    </motion.div>
  );
};

export default AchievementUnlocked;
